import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import ClinicLinkInputForm from './components/clinicLinkInput';
import React, { useState } from 'react';
import PatientInfoForm from './components/patientInfoForm';
import Loader from './components/loader';
import InvalidClinic from './components/invalidClinicLink';
import FinalLinkQr from './components/finalLinkQr';

function App() {
  const [validUrl, setValidUrl] = useState('');
  const [fields, setFields] = useState([]);
  const [lookups, setLookups] = useState({});
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [finalUrl, setFinalUrl] = useState('');

  
  const onLinkSubmit = async (link) => {
    console.log('api endpoint', process.env.REACT_APP_API_URL);
    const apiEndpoint = process.env.REACT_APP_API_URL || 'https://uat.videocall.org.au/api-slink/';
    setFinalUrl('');
    setMessage('');
    setFields([]);
    setLoading(true);
    const trimmedLink = link.trim();
    const response = await fetch(`${apiEndpoint}?clinic-url=${encodeURIComponent(trimmedLink)}`);
    const clinicDetails = await response.json();
    setValidUrl(clinicDetails.valid_url || '');
    setFields(clinicDetails.fields || []);
    setLookups(clinicDetails.lookups || {});
    setMessage(clinicDetails.message || '');
    setLoading(false);
  }

  const onPatientInfoSubmit = (patientInfo) => {
    const url = new URL(validUrl);
    url.searchParams.set("skipSetup", "1");
    url.searchParams.set("countryCode", "61");
    var additional = {};
    for (const pair of patientInfo.entries()){
        if (pair[0] === 'firstName' || pair[0] === 'lastName'){
           url.searchParams.set(pair[0], pair[1])
        } else {
          additional[pair[0]] = pair[1]
        }
    }
    url.searchParams.set("additional", encodeURIComponent(JSON.stringify(additional)));
    console.log(url.toString());
    setFinalUrl(url.toString());
  }
  
  const onPatientInfoChange = () => {
    setFinalUrl('');
    setMessage('');
  }

  return (
    <div className="App">
      {loading && <Loader />}
      {!loading && <ClinicLinkInputForm validUrl = {validUrl} onLinkSubmit={onLinkSubmit}/>}
      {!loading && message && <InvalidClinic />}
      {!loading && fields && lookups && <PatientInfoForm fields={fields} lookups={lookups} onPatientInfoSubmit={onPatientInfoSubmit} onPatientInfoChange={onPatientInfoChange}/>}
      {!loading && finalUrl && <FinalLinkQr finalLink={finalUrl} />}
    </div>
  );
}

export default App;
